import { render, staticRenderFns } from "./top_domains.vue?vue&type=template&id=74ae83e8&"
import script from "./top_domains.vue?vue&type=script&lang=js&"
export * from "./top_domains.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports